import Categories from "../components/Layout/Categories/Categories";

const CategoriesPage = () => {
  return <Categories />;
};

export default CategoriesPage;
